import React, { useRef } from 'react';

import { Blanket } from '@novo-electronique/react-blanket';

interface IProps {
  closeHandler?: () => void;
  children: JSX.Element | JSX.Element[];
}

export const SidePanelContext = React.createContext({ closeHandler: undefined });

function SidePanel({ children, closeHandler }: IProps) {
  const blanketRef = useRef<HTMLDivElement>(null);

  const onClose = (event: any) => {
    if (blanketRef.current.isSameNode(event.target) && closeHandler) {
      closeHandler();
    }
  };

  return (
    <SidePanelContext.Provider value={{ closeHandler }}>
      <Blanket onMouseDown={onClose} ref={blanketRef}>
        <article className="novoSidePanel">{children}</article>
      </Blanket>
    </SidePanelContext.Provider>
  );
}

export default SidePanel;
